import React, { useEffect } from 'react'
import { Form, Flex } from 'antd'
import styled from 'styled-components'
import { PrimaryButton } from '../../components/Button'
import { Icon } from '../../Icon/Icon'
import { MediumInput } from '../../components/Input'
import { FormItem } from '../FormItem/FormItem'

const FormContainer = styled.div`
  .ant-form-item {
    margin-bottom: 0;
  }
`

const FormInputs = styled(Flex)`
  gap: 24px;
`

const FormWrapper = styled(Flex)`
  gap: 48px;
`

export interface LoginFormData {
  login: string
  password: string
}

interface LoginFormProps {
  onSubmit: (data: LoginFormData) => void
  isLoading?: boolean
  error?: string | null
  onServerButtonClick?: () => void
  currentServer?: string
}

// const ValidateError = ({ message }: { message: string }) => (
//   <Flex gap={4} align="center">
//     <Icon name="input_error" size={12} />
//     <span>{message}</span>
//   </Flex>
// )

// const validateLatinAndNumbers = (_: any, value: string) => {
//   if (!value) {
//     return Promise.resolve()
//   }

//   const latinAndAllowedCharsRegex = /^[a-zA-Z0-9._%+-@]*$/

//   if (latinAndAllowedCharsRegex.test(value)) {
//     return Promise.resolve()
//   }

//   return Promise.reject(
//     <ValidateError message="Допустимы только латинские буквы и цифры" />
//   )
// }

export const LoginForm: React.FC<LoginFormProps> = ({
  onSubmit,
  isLoading = false,
  error = null,
  onServerButtonClick,
  currentServer = 'Сервер по умолчанию',
}) => {
  const [form] = Form.useForm()

  const handleSubmit = (values: LoginFormData) => {
    onSubmit(values)
  }

  useEffect(() => {
    if (error) {
      form.setFields([
        {
          name: 'login',
          errors: error ? [''] : [],
        },
        {
          name: 'password',
          errors: error ? [''] : [],
        },
      ])
    } else {
      form.setFields([
        {
          name: 'login',
          errors: [],
        },
        {
          name: 'password',
          errors: [],
        },
      ])
    }
  }, [error, form])

  return (
    <FormContainer>
      <Form form={form} name="login" onFinish={handleSubmit} autoComplete="off">
        <FormWrapper vertical>
          <FormInputs vertical>
            <FormItem name="login">
              <MediumInput
                label="Имя пользователя"
                suffix={<Icon name="login_user" size={16} />}
                placeholder="Введите имя пользователя"
                disabled={isLoading}
                status={error ? 'error' : undefined}
              />
            </FormItem>

            <FormItem name="password">
              <MediumInput
                label="Пароль"
                type="password"
                placeholder="Введите пароль"
                disabled={isLoading}
                visibilityToggle
                status={error ? 'error' : undefined}
              />
            </FormItem>
          </FormInputs>
          <FormItem>
            <Flex gap={24}>
              <PrimaryButton
                $fullWidth
                htmlType="submit"
                loading={isLoading}
                disabled={isLoading}
              >
                Войти
              </PrimaryButton>
              <PrimaryButton
                style={{ width: '40px' }}
                icon={<Icon name="login_server" size={16} />}
                onClick={onServerButtonClick}
                disabled={isLoading}
                title={`Текущий сервер: ${currentServer}`}
              />
            </Flex>
          </FormItem>
        </FormWrapper>
      </Form>
    </FormContainer>
  )
}
